import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import { VueAxios } from "@/utils/request"
import store from './store/'
import scroll from 'vue-seamless-scroll'
import vueAwesomeSwiper from 'vue-awesome-swiper'
import Print from 'vue-print-nb'

//全局样式
import "@/assets/css/app.css"
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import 'swiper/css/swiper.css'
import animated from 'animate.css'




import {
    ACCESS_TOKEN
} from "@/store/mutation-types"
Vue.use(Antd)
Vue.config.productionTip = false
Vue.use(VueAxios)
Vue.use(Storage)
Vue.use(scroll)
Vue.use(vueAwesomeSwiper)
Vue.use(animated)
Vue.use(Print);

new Vue({
    router,
    store,
    data:{
        minWith: 960, //小屏幕宽度
        isMinScreen: false,
        isLoadMobileCss: false
    },
    methods: {
        //检测是否是小屏幕
        checkMinScreen(){
            return document.body.clientWidth <= this.minWith
        },
    },
    mounted (){
        if (this.checkMinScreen()) {
            this.isMinScreen = true
        }
        // 监听窗口大小
        window.onresize = () => {
            if (document.body.clientWidth < this.minWith) {
                this.isMinScreen = true
            } else {
                this.isMinScreen = false
            }
        }
        store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
    },
    render: h => h(App),
}).$mount('#app')
